import React, { createContext, useContext, useState } from 'react';

const FreeTrialContext = createContext();

export const useFreeTrial = () => {
  const context = useContext(FreeTrialContext);
  if (!context) {
    throw new Error('useFreeTrial must be used within a FreeTrialProvider');
  }
  return context;
};

export const FreeTrialProvider = ({ children }) => {
  const [freeTrialUsed, setFreeTrialUsed] = useState(false);

  const markFreeTrialUsed = () => {
    setFreeTrialUsed(true);
    // 可以在这里添加本地存储逻辑，让状态持久化
    localStorage.setItem('plantProtectionFreeTrialUsed', 'true');
  };

  const checkFreeTrialStatus = () => {
    // 从本地存储检查状态
    const stored = localStorage.getItem('plantProtectionFreeTrialUsed');
    if (stored === 'true') {
      setFreeTrialUsed(true);
    }
    return freeTrialUsed;
  };

  const resetFreeTrial = () => {
    setFreeTrialUsed(false);
    localStorage.removeItem('plantProtectionFreeTrialUsed');
  };

  return (
    <FreeTrialContext.Provider value={{
      freeTrialUsed,
      markFreeTrialUsed,
      checkFreeTrialStatus,
      resetFreeTrial
    }}>
      {children}
    </FreeTrialContext.Provider>
  );
};

export default FreeTrialContext;


